import {SD_TreeModel} from "@app/routes/schematics/model/sd_tree-model";


export class SchematicsAction {
}

export class GetTemplateData {
  static readonly type = '[SchematicsState] Get Template Data';
  constructor(public id: number) {
  }
}

export class RemoveTemplateData {
  static readonly type = '[SchematicsState] Remove Template Data';
}

export class SetSelectedTreeItem {
  static readonly type = '[SchematicsState] Set Selected Tree View Item';
  constructor(public item: SD_TreeModel) {
  }
}

export class RemoveSelectedTreeItem {
  static readonly type = '[SchematicsState ] Removing Selected Tree Item';
}
